import React from 'react';
import { CheckboxInput, Typography } from '@hpi-sox/hpstellar-core/visId';

import useProductCompare from '../../../../../hooks/useProductCompare';
import { getCompare } from '../../../../get-product-props';
import { Helpers } from '../../../../../core/src/helpers';

import './compare-input.less';

export const CompareInput = ({ product, ctaText = 'Compare', classname }) => {
    const compareHooks = useProductCompare();
    const { compareBtnProps } = getCompare(product, compareHooks);
    const { compareChecked, onCompare } = compareBtnProps || {};
    const { name, title } = product || {};
    const productName = Helpers.decodeHtml(name || title || 'product');
    return (
        <div
            className={`compare-input${!onCompare ? ' compare-disabled' : ''} ${classname ? classname : ''}`}
            onClick={onCompare}
        >
            <CheckboxInput
                checked={compareChecked}
                disabled={!onCompare}
                onChange={() => {}}
                inputProps={{ 'aria-label': `Add ${productName} to compare` }}
            />
            <Typography variant="caption" className="compare-input-cta-text">
                {ctaText}
            </Typography>
        </div>
    );
};

export default ({ product, ctaText = 'Compare', classname }) => {
    return (
        <div className="product-compare">
            <CompareInput product={product} ctaText={ctaText} classname={classname} />
            <Typography variant="footnotes">{product.sku}</Typography>
        </div>
    );
};
